export const UnidadMedida = [
    {
        'id': '59',
        'codigo': 'BJ',
        'descripcion': 'BALDE'
        },
        {
        'id': '67',
        'codigo': 'RD',
        'descripcion': 'BARILLA'
        },
        {
        'id': '58',
        'codigo': 'BLL',
        'descripcion': 'BARRILES'
        },
        {
        'id': '62',
        'codigo': '4A',
        'descripcion': 'BOBINAS'
        },
        {
        'id': '60',
        'codigo': 'BG',
        'descripcion': 'BOLSA'
        },
        {
        'id': '21',
        'codigo': 'BO',
        'descripcion': 'BOTELLAS'
        },
        {
        'id': '57',
        'codigo': 'BX',
        'descripcion': 'CAJA'
        },
        {
        'id': '51',
        'codigo': 'CT',
        'descripcion': 'CARTONES'
        },
        {
        'id': '15',
        'codigo': 'CMK',
        'descripcion': 'CENTIMETRO CUADRADO'
        },
        {
        'id': '53',
        'codigo': 'CMQ',
        'descripcion': 'CENTIMETRO CUBICO'
        },
        {
        'id': '52',
        'codigo': 'CMT',
        'descripcion': 'CENTIMETRO LINEAL'
        },
        {
        'id': '7',
        'codigo': 'CEN',
        'descripcion': 'CIENTO DE UNIDADES'
        },
        {
        'id': '50',
        'codigo': 'CY',
        'descripcion': 'CILINDRO'
        },
        {
        'id': '54',
        'codigo': 'CJ',
        'descripcion': 'CONOS'
        },
        {
        'id': '68',
        'codigo': 'DAY',
        'descripcion': 'DIA'
        },
        {
        'id': '20',
        'codigo': 'DZN',
        'descripcion': 'DOCENA'
        },
        {
        'id': '48',
        'codigo': 'DZP',
        'descripcion': 'DOCENA POR 10**6'
        },
        {
        'id': '61',
        'codigo': 'BE',
        'descripcion': 'FARDO'
        },
        {
        'id': '45',
        'codigo': 'GLI',
        'descripcion': 'GALON INGLES(4,545956L)'
        },
        {
        'id': '44',
        'codigo': 'GLL',
        'descripcion': 'GALON US(3,7843L)'
        },
        {
        'id': '17',
        'codigo': 'GRM',
        'descripcion': 'GRAMO'
        },
        {
        'id': '43',
        'codigo': 'GRO',
        'descripcion': 'GRUESA'
        },
        {
        'id': '42',
        'codigo': 'HLT',
        'descripcion': 'HECTOLITRO'
        },
        {
        'id': '38',
        'codigo': 'LEF',
        'descripcion': 'HOJA'
        },
        {
        'id': '63',
        'codigo': 'HUR',
        'descripcion': 'HORAS'
        },
        {
        'id': '29',
        'codigo': 'SET',
        'descripcion': 'JUEGO'
        },
        {
        'id': '70',
        'codigo': 'SET',
        'descripcion': 'SET'
        },
        {
        'id': '2',
        'codigo': 'KGM',
        'descripcion': 'KILOGRAMO'
        },
        {
        'id': '5',
        'codigo': 'KTM',
        'descripcion': 'KILOMETRO'
        },
        {
        'id': '39',
        'codigo': 'KWH',
        'descripcion': 'KILOVATIO HORA'
        },
        {
        'id': '40',
        'codigo': 'KT',
        'descripcion': 'KIT'
        },
        {
        'id': '55',
        'codigo': 'CA',
        'descripcion': 'LATAS'
        },
        {
        'id': '4',
        'codigo': 'LBR',
        'descripcion': 'LIBRAS'
        },
        {
        'id': '3',
        'codigo': 'LTR',
        'descripcion': 'LITRO'
        },
        {
        'id': '35',
        'codigo': 'MWH',
        'descripcion': 'MEGAWATT HORA'
        },
        {
        'id': '8',
        'codigo': 'MTR',
        'descripcion': 'METRO'
        },
        {
        'id': '12',
        'codigo': 'MTK',
        'descripcion': 'METRO CUADRADO'
        },
        {
        'id': '11',
        'codigo': 'MTQ',
        'descripcion': 'METRO CUBICO'
        },
        {
        'id': '36',
        'codigo': 'MGM',
        'descripcion': 'MILIGRAMOS'
        },
        {
        'id': '9',
        'codigo': 'MLT',
        'descripcion': 'MILILITRO'
        },
        {
        'id': '16',
        'codigo': 'MMT',
        'descripcion': 'MILIMETRO'
        },
        {
        'id': '14',
        'codigo': 'MMK',
        'descripcion': 'MILIMETRO CUADRADO'
        },
        {
        'id': '13',
        'codigo': 'MMQ',
        'descripcion': 'MILIMETRO CUBICO'
        },
        {
        'id': '10',
        'codigo': 'MIL',
        'descripcion': 'MILLARES'
        },
        {
        'id': '25',
        'codigo': 'UM',
        'descripcion': 'MILLON DE UNIDADES'
        },
        {
        'id': '64',
        'codigo': 'AH',
        'descripcion': 'MINUTO'
        },
        {
        'id': '18',
        'codigo': 'ONZ',
        'descripcion': 'ONZAS'
        },
        {
        'id': '33',
        'codigo': 'PF',
        'descripcion': 'PALETAS'
        },
        {
        'id': '6',
        'codigo': 'PK',
        'descripcion': 'PAQUETE'
        },
        {
        'id': '31',
        'codigo': 'PR',
        'descripcion': 'PAR'
        },
        {
        'id': '22',
        'codigo': 'FOT',
        'descripcion': 'PIES'
        },
        {
        'id': '47',
        'codigo': 'FTK',
        'descripcion': 'PIES CUADRADOS'
        },
        {
        'id': '46',
        'codigo': 'FTQ',
        'descripcion': 'PIES CUBICOS'
        },
        {
        'id': '56',
        'codigo': 'C62',
        'descripcion': 'PIEZAS'
        },
        {
        'id': '32',
        'codigo': 'PG',
        'descripcion': 'PLACAS'
        },
        {
        'id': '28',
        'codigo': 'ST',
        'descripcion': 'PLIEGO'
        },
        {
        'id': '41',
        'codigo': 'INH',
        'descripcion': 'PULGADAS'
        },
        {
        'id': '30',
        'codigo': 'RM',
        'descripcion': 'RESMA'
        },
        {
        'id': '65',
        'codigo': 'RO',
        'descripcion': 'ROLLO'
        },
        {
        'id': '66',
        'codigo': 'RK',
        'descripcion': 'ROLLO MED. METRICA'
        },
        {
        'id': '49',
        'codigo': 'DR',
        'descripcion': 'TAMBOR'
        },
        {
        'id': '69',
        'codigo': 'SR',
        'descripcion': 'TIRA'
        },
        {
        'id': '27',
        'codigo': 'STN',
        'descripcion': 'TONELADA CORTA'
        },
        {
        'id': '37',
        'codigo': 'LTN',
        'descripcion': 'TONELADA LARGA'
        },
        {
        'id': '19',
        'codigo': 'TNE',
        'descripcion': 'TONELADAS'
        },
        {
        'id': '26',
        'codigo': 'TU',
        'descripcion': 'TUBOS'
        },
        {
        'id': '34',
        'codigo': 'NIU',
        'descripcion': 'UNIDAD'
        },
        {
        'id': '1',
        'codigo': 'ZZ',
        'descripcion': 'SERVICIO'
        },
        {
        'id': '23',
        'codigo': 'YRD',
        'descripcion': 'YARDA'
        },
        {
        'id': '24',
        'codigo': 'YDK',
        'descripcion': 'YARDA CUADRADA'
        },
]

export const ListaOperacionF = [
    {
        tipo: "0101",
        name: "Venta interna"
    },
    {
        tipo: '0112',
        name: 'Venta Interna - Sustenta Gastos Deducibles Persona Natural'
    },
    {
        tipo: '0113',
        name: 'Venta Interna-NRUS'
    },
    {
        tipo: '0200',
        name: 'Exportación de Bienes'
    },
    {
        tipo: "0101EDU",
        name: "SERVICIOS EDUCATIVOS"
    },
    /*{
        tipo: '0201',
        name: 'Exportación de Servicios – Prestación servicios realizados íntegramente en el país'
    },
    {
        tipo: '0202',
        name: 'Exportación de Servicios – Prestación de servicios de hospedaje No Domiciliado'
    },
    {
        tipo: '0203',
        name: 'Exportación de Servicios – Transporte de navieras'
    },
    {
        tipo: '0204',
        name: 'Exportación de Servicios – Servicios  a naves y aeronaves de bandera extranjera'
    },
    {
        tipo: '0205',
        name: 'Exportación de Servicios  - Servicios que conformen un Paquete Turístico'
    },
    {
        tipo: '0206',
        name: 'Exportación de Servicios – Servicios complementarios al transporte de carga'
    },
    {
        tipo: '0207',
        name: 'Exportación de Servicios – Suministro de energía eléctrica a favor de sujetos domiciliados en ZED'
    },
    {
        tipo: '0208',
        name: 'Exportación de Servicios – Prestación servicios realizados parcialmente en el extranjero'
    },
    {
        tipo: '0301',
        name: 'Operaciones con Carta de porte aéreo (emitidas en el ámbito nacional)'
    },
    {
        tipo: '0302',
        name: 'Operaciones de Transporte ferroviario de pasajeros'
    },
    {
        tipo: '0303',
        name: 'Operaciones de Pago de regalía petrolera'
    },
    {
        tipo: '0401',
        name: 'Ventas no domiciliados que no califican como exportación'
    },*/
    {
        tipo: '1001',
        name: 'Operación Sujeta a Detracción'
    },
    {
        tipo: '1002',
        name: 'Operación Sujeta a Detracción- Recursos Hidrobiológicos'
    },
    // {
    //     tipo: '1003',
    //     name: 'Operación Sujeta a Detracción- Servicios de Transporte Pasajeros'
    // },
    {
        tipo: '1004',
        name: 'Operación Sujeta a Detracción- Servicios de Transporte Carga'
    },
    /*
    {
        tipo: '2001',
        name: 'Operación Sujeta a Percepción'
    }*/ 
]

export const ListaOperacionB = [
    {
        tipo: "0101",
        name: "Venta interna"
    },
    {
        tipo: '0112',
        name: 'Venta Interna - Sustenta Gastos Deducibles Persona Natural'
    },
    {
        tipo: '0113',
        name: 'Venta Interna-NRUS'
    },
    {
        tipo: "0101EDU",
        name: "SERVICIOS EDUCATIVOS"
    },
]
export const incoterm = [
    {
        tipo: "1",
        name: "DPU"
    },
    {
        tipo: '2',
        name: 'FCA'
    },
    {
        tipo: '3',
        name: 'EXW'
    },
    {
        tipo: "4",
        name: "FOB"
    },
    {
        tipo: '5',
        name: 'FAS'
    },
    {
        tipo: '6',
        name: 'FCA'
    },
    {
        tipo: "7",
        name: "CIP"
    },
    {
        tipo: '8',
        name: 'CIF'
    },
    {
        tipo: '9',
        name: 'CPT'
    },
    {
        tipo: "10",
        name: "CFR"
    },
    {
        tipo: '11',
        name: 'DAP'
    },
    {
        tipo: '12',
        name: 'DAT'
    },
    {
        tipo: '13',
        name: 'DDP'
    }
    
]

export const ListaOperacionP = [
    {
        codigo: "01",
        descripcion: "Percepción Venta Interna",
        porcentaje: '2.00'
    },
    {
        codigo: '02',
        descripcion: 'Percepción a la adquisición de combustible',
        porcentaje: '1.00'
    },
    {
        codigo: '03',
        descripcion: 'Percepción realizada al agente de percepción con tasa especial',
        porcentaje: '0.50'
    }
]
export const tasaRetencionR = [
    {
        codigo: "01",
        descripcion: "Tasa Retención",
        tasa: "3.00"
    },
]
export const TipoAfectacion = [
    {
        id: '02',
        descripcion: 'Inafecto'
    },
    {
        id: '01',
        descripcion: 'Gravado'
    },
    {
        id: '03',
        descripcion: 'Exonerado'
    }
]

export const EspecificacionIgvTipo1 = [
    // {
    //     codigo: '10',
    //     descripcion: 'Operacion onerosa',
    //     codigoTributo: '1000'
    // },
    {
        codigo: '11',
        descripcion: 'Retiro por premio',
        codigoTributo: '9996'
    },
    {
        codigo: '12',
        descripcion: 'Retiro por donacion',
        codigoTributo: '9996'
    },
    {
        codigo: '13',
        descripcion: 'Retiro',
        codigoTributo: '9996'
    },
    {
        codigo: '14',
        descripcion: 'Retiro por publicidad',
        codigoTributo: '9996'
    },
    {
        codigo: '15',
        descripcion: 'Grabado - Bonificaciones',
        codigoTributo: '9996'
    },
    {
        codigo: '16',
        descripcion: 'Retiro por entrega a trabajadores',
        codigoTributo: '9996'
    }  
]

export const EspecificacionIgvTipo2 = [
    // {
    //     codigo: '30',
    //     descripcion: 'Operación Onerosa',
    //     codigoTributo: '9998'
    // },
    {
        codigo: '31',
        descripcion: 'Retiro por Bonificación',
        codigoTributo: '9996'
    },
    {
        codigo: '32',
        descripcion: 'Retiro',
        codigoTributo: '9996'
    },
    {
        codigo: '33',
        descripcion: 'Retiro por Muestras Médicas',
        codigoTributo: '9996'
    },
    {
        codigo: '34',
        descripcion: 'Retiro por Convenio Colectivo',
        codigoTributo: '9996'
    },
    {
        codigo: '35',
        descripcion: 'Retiro por Convenio Colectivo',
        codigoTributo: '9996'
    },
    {
        codigo: '36',
        descripcion: 'Retiro por publicidad',
        codigoTributo: '9996'
    }
]

export const EspecificacionIgvTipo3 = [
    // { 
    //     codigo: "20",
    //     descripcion: "Operación Onerosa", 
    //     codigoTributo: "9997" 
    // },
    {
        codigo: "21",
        descripcion: "Transferencia gratuita",
        codigoTributo: "9996"
    }
]

export const TipoMoneda = [
    {
        id: '1',
        codigo: 'PEN',
        descripcion: 'SOLES',
        simbolo: 'S/.'
    },
    {
        id: '2',
        codigo: 'EUR',
        descripcion: 'EUROS',
        simbolo: '\u20ac'
    },
    {
        id: '3',
        codigo: 'USD',
        descripcion: 'DOLARES AMERICANOS',
        simbolo: '$'
    },
    {
        id: '4',
        codigo: 'CAD',
        descripcion: 'DOLARES CANADIENSES',
        simbolo: 'C$'
    },
    {
        id: '5',
        codigo: 'GBP',
        descripcion: 'LIBRAS ESTERLINAS',
        simbolo: '\u00a3'
    },
    {
        id: '6',
        codigo: 'JPY',
        descripcion: 'YENES',
        simbolo: '\u00a5'
    },
    {
        id: '7',
        codigo: 'SEK',
        descripcion: 'CORONAS SUECAS',
        simbolo: 'kr'
    },
    {
        id: '8',
        codigo: 'CHF',
        descripcion: 'FRANCOS SUIZOS',
        simbolo: 'Fr'
    }
]

export const FormaPagoCuentasCobrar = [
    {
        codigo: '000',
        nombre: 'Elige Forma de Pago'
    },
    {
        codigo: '00',
        nombre: 'A Crédito'
    },
    {
        codigo: '001',
        nombre: 'Depósito en cuenta'
    },
    {
        codigo: '003',
        nombre: 'Transferencia de fondos'
    },
    {
        codigo: '005',
        nombre: 'Tarjeta de débito'
    },
    {
        codigo: '006',
        nombre: 'Tarjeta de Crédito emitida en Perú'
    },
    {
        codigo: '012',
        nombre: 'Tarjeta de crédito emitida en el país o en el exterior por una empresa no perteneciente al sistema financiero.'
    },
    {
        codigo: '013',
        nombre: 'Tarjeta de Crédito del exterior'
    },
    {
        codigo: '008',
        nombre: 'Efectivo ventas menores'
    },
    {
        codigo: '009',
        nombre: 'Efectivo demás casos'
    },
    {
        codigo: '010',
        nombre: 'Medios de Pago de comercio exterior'
    },
    {
        codigo: '011',
        nombre: 'Documentos emitidos por EDPYMES y Cooperativas'
    },
    {
        codigo: '007',
        nombre: 'Cheques No Negociables'
    }, 
    {
        codigo: '101',
        nombre: 'Transferencia - Comercio Exterior'
    },
    {
        codigo: '102',
        nombre: 'Cheques bancarios - Comercio Exterior'
    },
    {
        codigo: '103',
        nombre: 'Orden de Pago - Comercio Exterior'
    },
    {
        codigo: '104',
        nombre: 'Orden de pago documentario - Comercio exterior'
    },
    {
        codigo: '105',
        nombre: 'Remesa Simple - Comercio Exterior'
    },
    {
        codigo: '106',
        nombre: 'Remesa Documentaria - Comercio Exterior'
    },
    {
        codigo: '107',
        nombre: 'Carta de crédito simple - Comercio Exterior'
    },
    {
        codigo: '108',
        nombre: 'Carta de crédito documentario - Comercio Exterior'
    },
    {
        codigo: '999',
        nombre: 'Otros medios de pago'
    },
    {
        codigo: '002',
        nombre: 'Giro'
    },
    {
        codigo: '004',
        nombre: 'Orden de pago'
    },
]
export const FormaPag = [
    {
        codigo: '000',
        nombre: 'Elige Forma de Pago'
    },
    {
        codigo: '001',
        nombre: 'Depósito en cuenta'
    },
    {
        codigo: '003',
        nombre: 'Transferencia de fondos'
    },
    {
        codigo: '005',
        nombre: 'Tarjeta de débito'
    },
    {
        codigo: '006',
        nombre: 'Tarjeta de Crédito emitida en Perú'
    },
    {
        codigo: '012',
        nombre: 'Tarjeta de crédito emitida en el país o en el exterior por una empresa no perteneciente al sistema financiero.'
    },
    {
        codigo: '013',
        nombre: 'Tarjeta de Crédito del exterior'
    },
    {
        codigo: '008',
        nombre: 'Efectivo ventas menores'
    },
    {
        codigo: '009',
        nombre: 'Efectivo demás casos'
    },
    {
        codigo: '010',
        nombre: 'Medios de Pago de comercio exterior'
    },
    {
        codigo: '011',
        nombre: 'Documentos emitidos por EDPYMES y Cooperativas'
    },
    {
        codigo: '007',
        nombre: 'Cheques No Negociables'
    }, 
    {
        codigo: '101',
        nombre: 'Transferencia - Comercio Exterior'
    },
    {
        codigo: '102',
        nombre: 'Cheques bancarios - Comercio Exterior'
    },
    {
        codigo: '103',
        nombre: 'Orden de Pago - Comercio Exterior'
    },
    {
        codigo: '104',
        nombre: 'Orden de pago documentario - Comercio exterior'
    },
    {
        codigo: '105',
        nombre: 'Remesa Simple - Comercio Exterior'
    },
    {
        codigo: '106',
        nombre: 'Remesa Documentaria - Comercio Exterior'
    },
    {
        codigo: '107',
        nombre: 'Carta de crédito simple - Comercio Exterior'
    },
    {
        codigo: '108',
        nombre: 'Carta de crédito documentario - Comercio Exterior'
    },
    {
        codigo: '999',
        nombre: 'Otros medios de pago'
    },
    {
        codigo: '002',
        nombre: 'Giro'
    },
    {
        codigo: '004',
        nombre: 'Orden de pago'
    },
]

export const FormaPago = [
    {
        codigo: '000',
        nombre: 'Elige Forma de Pago'
    },
    {
        codigo: '001',
        nombre: 'Depósito en cuenta'
    },
    {
        codigo: '002',
        nombre: 'Giro'
    },
    {
        codigo: '003',
        nombre: 'Transferencia de fondos'
    },
    {
        codigo: '004',
        nombre: 'Orden de pago'
    },
    {
        codigo: '005',
        nombre: 'Tarjeta de débito'
    },
    {
        codigo: '006',
        nombre: 'Tarjeta de Crédito emitida en Perú'
    },
    {
        codigo: '007',
        nombre: 'Cheques No Negociables'
    },
    {
        codigo: '008',
        nombre: 'Efectivo ventas menores'
    },
    {
        codigo: '009',
        nombre: 'Efectivo demás casos'
    },
    {
        codigo: '010',
        nombre: 'Medios de Pago de comercio exterior'
    },
    {
        codigo: '011',
        nombre: 'Documentos emitidos por EDPYMES y Cooperativas'
    },
    {
        codigo: '012',
        nombre: 'Tarjeta de crédito emitida en el país o en el exterior por una empresa no perteneciente al sistema financiero.'
    },
    {
        codigo: '013',
        nombre: 'Tarjeta de Crédito del exterior'
    },
    {
        codigo: '101',
        nombre: 'Transferencia - Comercio Exterior'
    },
    {
        codigo: '102',
        nombre: 'Cheques bancarios - Comercio Exterior'
    },
    {
        codigo: '103',
        nombre: 'Orden de Pago - Comercio Exterior'
    },
    {
        codigo: '104',
        nombre: 'Orden de pago documentario - Comercio exterior'
    },
    {
        codigo: '105',
        nombre: 'Remesa Simple - Comercio Exterior'
    },
    {
        codigo: '106',
        nombre: 'Remesa Documentaria - Comercio Exterior'
    },
    {
        codigo: '107',
        nombre: 'Carta de crédito simple - Comercio Exterior'
    },
    {
        codigo: '108',
        nombre: 'Carta de crédito documentario - Comercio Exterior'
    },
    {
        codigo: '998',
        nombre: 'Nota de Credito'
    },
    {
        codigo: '999',
        nombre: 'Otros medios de pago'
    },
]

export const FormaPagoPDV = [
    {
        codigo: '008',
        nombre: 'Efectivo ventas menores'
    },
    {
        codigo: '009',
        nombre: 'Efectivo demás casos'
    },
    {
        codigo: '005',
        nombre: 'Tarjeta de débito'
    },
    {
        codigo: '006',
        nombre: 'Tarjeta de Crédito emitida en Perú'
    },
    {
        codigo: '012',
        nombre: 'Tarjeta de crédito emitida en el país o en el exterior por una empresa no perteneciente al sistema financiero.'
    },
    {
        codigo: '013',
        nombre: 'Tarjeta de Crédito del exterior'
    },
    {
        codigo: '001',
        nombre: 'Depósito en cuenta'
    },
    {
        codigo: '999',
        nombre: 'Otros medios de pago'
    },
    {
        codigo: '00',
        nombre: 'A Crédito'
    },
    {
        codigo: '003',
        nombre: 'Transferencia de fondos'
    },
]

export const tipoVehiculoOpcion = [
    {
        codigo: '01',
        nombre: 'Auto o Moto'
    },
    {
        codigo: '02',
        nombre: 'Otros vehículos'
    },
    
]
export const TipoGuia = [
    {
        codigo: '09',
        nombre: 'Guia Remision Remitente'
    },
    {
        codigo: '0',
        nombre: 'Guia Remision Contingencia'
    },
    // {
    //     codigo: "31",
    //     nombre: "Guia Remision Transportista"
    // }
]

export const DocumentosIdentidad = [
      {
          nombre: 'Sin Documento',
          tipo: '0'
      },
      {
          nombre: 'DNI',
          tipo: '1'
      },
      {
          nombre: 'Carnet de Extranjeria',
          tipo: '4'
      },
      {
          nombre: 'RUC',
          tipo: '6'
      },
      {
          nombre: 'Pasaporte',
          tipo: '7'
      },
      {
          nombre: 'Cedula Diplomatica de Identidad',
          tipo: 'A'
      },
      {
          nombre: 'DOC.IDENT.PAIS.RESIDENCIA-NO.D',
          tipo: 'B'
      },
      {
          nombre: 'Doc Trib PP.NN',
          tipo: 'C'
      },
      {
          nombre: 'Doc Trib PP. JJ',
          tipo: 'D'
      },
      {
          nombre: 'TAM- Tarjeta Andina de Migración ',
          tipo: 'E'
      }
]
export const DocPersonal = [
    {
        nombre: 'Sin Documento',
        tipo: '0'
    },
    {
        nombre: 'DNI',
        tipo: '01'
    },
    {
        nombre: 'Carnet de Extranjeria',
        tipo: '04'
    },
    {
        nombre: 'RUC',
        tipo: '06'
    },
    {
        nombre: 'Pasaporte',
        tipo: '07'
    },
    {
        nombre: 'Cedula Diplomatica de Identidad',
        tipo: 'A'
    },
    {
        nombre: 'DOC.IDENT.PAIS.RESIDENCIA-NO.D',
        tipo: 'B'
    },
    {
        nombre: 'Doc Trib PP.NN',
        tipo: 'C'
    },
    {
        nombre: 'Doc Trib PP. JJ',
        tipo: 'D'
    },
    {
        nombre: 'TAM- Tarjeta Andina de Migración ',
        tipo: 'E'
    }
]

export const DocumentosIdentidadTerceros = [
    {
        nombre: 'Sin Documento',
        tipo: '0'
    },
    {
        nombre: 'DNI',
        tipo: '1'
    },
    {
        nombre: 'Carnet de Extranjeria',
        tipo: '4'
    },
    {
        nombre: 'RUC',
        tipo: '6'
    },
    {
        nombre: 'Pasaporte',
        tipo: '7'
    },
    {
        nombre: 'Cedula Diplomatica de Identidad',
        tipo: 'A'
    },
    {
        nombre: 'DOC.IDENT.PAIS.RESIDENCIA-NO.D',
        tipo: 'B'
    },
    {
        nombre: 'Doc Trib PP.NN',
        tipo: 'C'
    },
    {
        nombre: 'Doc Trib PP. JJ',
        tipo: 'D'
    },
    {
        nombre: 'TAM- Tarjeta Andina de Migración ',
        tipo: 'E'
    },
    {
        nombre: 'Otros (Exportación)',
        tipo: '10'
    },
]

export const DocumentosIdentidadExtrangeros = [
    {
        nombre: 'Otros',
        tipo: '0'
    },
    {
        nombre: 'Carnet de Extranjeria',
        tipo: '4'
    },
    {
        nombre: 'RUC',
        tipo: '6'
    },
    {
        nombre: 'Pasaporte',
        tipo: '7'
    },
    {
        nombre: 'Cedula Diplomatica de Identidad',
        tipo: 'A'
    },
    {
        nombre: 'DOC.IDENT.PAIS.RESIDENCIA-NO.D',
        tipo: 'B'
    },
    {
        nombre: 'Doc Trib PP.NN',
        tipo: 'C'
    },
    {
        nombre: 'Doc Trib PP. JJ',
        tipo: 'D'
    },
    {
        nombre: 'TAM- Tarjeta Andina de Migración ',
        tipo: 'E'
    }
]

export const DocumentosIdentidadConductor = [
    {
        nombre: 'DNI',
        tipo: '1'
    },
    {
        nombre: 'Carnet de Extranjeria',
        tipo: '4'
    },
    {
        nombre: 'RUC',
        tipo: '6'
    },
    {
        nombre: 'Pasaporte',
        tipo: '7'
    },
    {
        nombre: 'Cedula Diplomatica de Identidad',
        tipo: 'A'
    },
    {
        nombre: 'DOC.IDENT.PAIS.RESIDENCIA-NO.D',
        tipo: 'B'
    },
    {
        nombre: 'Doc Trib PP.NN',
        tipo: 'C'
    },
    {
        nombre: 'Doc Trib PP. JJ',
        tipo: 'D'
    },
    {
        nombre: 'TAM- Tarjeta Andina de Migración ',
        tipo: 'E'
    }
]

export const DocumentosIdentidadGuia = [
    {
        nombre: 'DNI',
        tipo: '1'
    },
    {
        nombre: 'Carnet de Extranjeria',
        tipo: '4'
    },
    {
        nombre: 'RUC',
        tipo: '6'
    },
    {
        nombre: 'Pasaporte',
        tipo: '7'
    },
    {
        nombre: 'Cedula Diplomatica de Identidad',
        tipo: 'A'
    },
    {
        nombre: 'DOC.IDENT.PAIS.RESIDENCIA-NO.D',
        tipo: 'B'
    },
    {
        nombre: 'Doc Trib PP.NN',
        tipo: 'C'
    },
    {
        nombre: 'Doc Trib PP. JJ',
        tipo: 'D'
    },
    {
        nombre: 'TAM- Tarjeta Andina de Migración ',
        tipo: 'E'
    }
]
export const DocumentosIdentidadPersona = [
    {
        nombre: 'DNI',
        tipo: '1'
    },
    {
        nombre: 'Carnet de Extranjeria',
        tipo: '4'
    },
    {
        nombre: 'RUC',
        tipo: '6'
    },
    {
        nombre: 'Pasaporte',
        tipo: '7'
    },
    {
        nombre: 'Cedula Diplomatica de Identidad',
        tipo: 'A'
    },
    {
        nombre: 'DOC.IDENT.PAIS.RESIDENCIA-NO.D',
        tipo: 'B'
    },
    {
        nombre: 'Doc Trib PP.NN',
        tipo: 'C'
    },
    {
        nombre: 'Doc Trib PP. JJ',
        tipo: 'D'
    },
    {
        nombre: 'TAM- Tarjeta Andina de Migración ',
        tipo: 'E'
    }
]
export const DocumentosViajero = [
    {
        nombre: 'DNI',
        tipo: '1'
    },
    {
        nombre: 'Carnet de Extranjeria',
        tipo: '4'
    },
    {
        nombre: 'Pasaporte',
        tipo: '7'
    },
    {
        nombre: 'Cedula Diplomatica de Identidad',
        tipo: 'A'
    },
    {
        nombre: 'DOC.IDENT.PAIS.RESIDENCIA-NO.D',
        tipo: 'B'
    },
    {
        nombre: 'Doc Trib PP.NN',
        tipo: 'C'
    },
    {
        nombre: 'Doc Trib PP. JJ',
        tipo: 'D'
    },
    {
        nombre: 'TAM- Tarjeta Andina de Migración ',
        tipo: 'E'
    }
]

export const DocumentosHuesped = [
    {
        nombre: 'Carnet de Extranjeria',
        tipo: '4'
    },
    {
        nombre: 'Pasaporte',
        tipo: '7'
    },
    {
        nombre: 'Cedula Diplomatica de Identidad',
        tipo: 'A'
    },
    {
        nombre: 'DOC.IDENT.PAIS.RESIDENCIA-NO.D',
        tipo: 'B'
    },
    {
        nombre: 'Doc Trib PP.NN',
        tipo: 'C'
    },
    {
        nombre: 'Doc Trib PP. JJ',
        tipo: 'D'
    },
    {
        nombre: 'TAM- Tarjeta Andina de Migración ',
        tipo: 'E'
    }
]
export const tiposNotaCreditoF = [
    {
        codigo: '01',
        nombre: 'Anulacion de la Operacion'
    },
    // {
    //     codigo: '02',
    //     nombre: 'Anulacion por Error en el RUC'
    // },
    {
        codigo: '03',
        nombre: 'Correccion por error en la descripcion'

    },
    {
        codigo: '04',
        nombre: 'Descuento Global'

    },
    {
        codigo: '05',
        nombre: 'Descuento por item'
    },
    {
        codigo: '06',
        nombre: 'Devolucion Total'
    },
    {
        codigo: '07',
        nombre: 'Devolucion parcial'
    },
    // {
    //     codigo: '08',
    //     nombre: 'Bonificación'
    // },
    // {
    //     codigo: '09',
    //     nombre: 'Disminucion en el valor'
    // }
    {
        codigo: '13',
        nombre: 'Crédito (ajustes fechas y/o montos)'
    },
]
export const tiposNotaCreditoB = [
    {
        codigo: '01',
        nombre: 'Anulacion de la Operacion'
    },
    // {
    //     codigo: '02',
    //     nombre: 'Anulacion por Error en el RUC'
    // },
    {
        codigo: '03',
        nombre: 'Correccion por error en la descripcion'
    },
    {
        codigo: '04',
        nombre: 'Descuento Global'
    },
    {
        codigo: '05',
        nombre: 'Descuento por item'
    },
    {
        codigo: '06',
        nombre: 'Devolucion Total'
    },
    {
        codigo: '07',
        nombre: 'Devolucion parcial'
    },
    // {
    //     codigo: '09',
    //     nombre: 'Disminucion en el valor'
    // }
    {
        codigo: '13',
        nombre: 'Crédito'
    },
]

export const tiposNotaDebitoF = [
    {
        codigo: '01',
        nombre: 'Interes por Mora'
    },
    {
        codigo: '02',
        nombre: 'Aumento en el  valor'
    },
    // {
    //     codigo: '03',
    //     nombre: 'Penalidades/ otros conceptos'
    // },
    // {
    //     codigo: '11',
    //     nombre: 'Ajustes de operaciones de exportación'
    // },
    // {
    //     codigo: '12',
    //     nombre: 'Ajustes afectos al IVAP'
    // }
]

export const MotivoTraslado = [
    {
        codigo: '01',
        nombre: 'Venta'
    },
    {
        codigo: '02',
        nombre: 'Compra'
    },
    {
        codigo: '04',
        nombre: 'Traslado entre establecimientos de la misma empresa'
    },
    {
        codigo: '05',
        nombre: 'Consignación'
    },
    {
        codigo: '06',
        nombre: 'Devolución'
    },
    {
        codigo: '08',
        nombre: 'Importación'
    },
    // {
    //     codigo: '09',
    //     nombre: 'Exportación'
    // },
    // {
    //     codigo: '19',
    //     nombre: 'Traslado a zona primaria'
    // },
    {
        codigo: '14',
        nombre: 'Venta sujeta a confirmacion del comprador'
    },   
    {
        codigo: '18',
        nombre: 'Emisor Itinerante'
    },
    {
        codigo: '13',
        nombre: 'Otros'
    }
] 

export const Departamentos = [
    {
        codDepartamento: "00",
        nombre: "Selecciona Departamento"
    },
    {
        codDepartamento:"01",
        nombre:"AMAZONAS"
    },
    {
        codDepartamento:"02", 
        nombre:"ANCASH"
    }, 
    {
        codDepartamento:"03", 
        nombre:"APURIMAC"
    }, 
    {
        codDepartamento:"04", 
    nombre:"AREQUIPA"
    }, 
    {
        codDepartamento:"05", 
    nombre:"AYACUCHO"
    }, 
    {
        codDepartamento:"06", 
    nombre:"CAJAMARCA"
    }, 
    {
        codDepartamento:"07", 
    nombre:"CALLAO"
    },
    {
        codDepartamento:"08", 
    nombre:"CUSCO"
    }, 
    {
        codDepartamento:"09", 
    nombre:"HUANCAVELICA"
    }, 
    {
        codDepartamento:"10", 
    nombre:"HUANUCO"
    }, 
    {
        codDepartamento:"11", 
    nombre:"ICA"
    }, 
    {
        codDepartamento:"12", 
    nombre:"JUNIN"
    }, 
    {
        codDepartamento:"13", 
    nombre:"LA LIBERTAD"
    }, 
    {
        codDepartamento:"14", 
    nombre:"LAMBAYEQUE"
    }, 
    {
        codDepartamento:"15", 
    nombre:"LIMA"
    }, 
    {
        codDepartamento:"16", 
    nombre:"LORETO"
    }, 
    {
        codDepartamento:"17", 
    nombre:"MADRE DE DIOS"
    }, 
    {
        codDepartamento:"18", 
    nombre:"MOQUEGUA"
    }, 
    {
        codDepartamento:"19", 
    nombre:"PASCO"
    }, 
    {
        codDepartamento:"20", 
    nombre:"PIURA"
    }, 
    {
        codDepartamento:"21", 
    nombre:"PUNO"
    }, 
    {
        codDepartamento:"22", 
    nombre:"SAN MARTIN"
    }, 
    {
        codDepartamento:"23", 
    nombre:"TACNA"
    }, 
    {
        codDepartamento:"24", 
    nombre:"TUMBES"
    }, 
    {
        codDepartamento:"25", 
    nombre:"UCAYALI"
    }, 
]

export const DocumentosRelacionadosTransportePrivado = [
    {
        codigo: '01',
        descripcion: 'DAM'
    },
    {
        codigo: '02',
        descripcion: 'Número de orden de entrega'
    },
    {
        codigo: '03',
        descripcion: 'Número SCOP'
    },
    {
        codigo: '04',
        descripcion: 'Número de manifiesto de carga'
    },
    {
        codigo: '05',
        descripcion: 'Número de constancia de detracción'
    },
    {
        codigo: '06',
        descripcion: 'Otros'
    },
]

export const DocumentosRelacionadosTransportePublico = [
    {
        codigo: '01',
        descripcion: 'DAM'
    },
    // {
    //     codigo: '02',
    //     descripcion: 'Número de orden de entrega'
    // },
    // {
    //     codigo: '03',
    //     descripcion: 'Número SCOP'
    // },
    {
        codigo: '04',
        descripcion: 'Manifiesto de carga'
    },
    // {
    //     codigo: '05',
    //     descripcion: 'Número de constancia de detracción'
    // },
    // {
    //     codigo: '06',
    //     descripcion: 'Otros'
    // },
]

export const listaDetraciones = [
    {
        codigo: '000',
        descripcion: 'Seleccionar tipo detraccion',
        porcentajeDetraccion: '0%'
    },
    {
        codigo: '001',
        descripcion: 'Azúcar y melaza de caña',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '002',
        descripcion: 'Arroz',
        porcentajeDetraccion: '3.85%'
    },
    {
        codigo: '003',
        descripcion: 'Alcohol etílico',
        porcentajeDetraccion: '10%'
    },    
    // {
    //     codigo: '004',
    //     descripcion: 'Recursos hidrobiológicos',
    //     porcentajeDetraccion: '4%'
    // },
    {
        codigo: '005',
        descripcion: 'Maíz amarillo duro',
        porcentajeDetraccion: '4%'
    },
    {
        codigo: '007',
        descripcion: 'Caña de azúcar',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '008',
        descripcion: 'Madera',
        porcentajeDetraccion: '4%'
    },
    {
        codigo: '009',
        descripcion: 'Arena y piedra.',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '010',
        descripcion: 'Residuos, subproductos, desechos, recortes y desperdicios',
        porcentajeDetraccion: '15%'
    },
    {
        codigo: '011',
        descripcion: 'Bienes gravados con el IGV, o renuncia a la exoneración',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '012',
        descripcion: 'Intermediación laboral y tercerización',
        porcentajeDetraccion: '12%'
    },
    {
        codigo: '013',
        descripcion: 'Animales vivos',
        porcentajeDetraccion: '1.5%'
    },
    {
        codigo: '014',
        descripcion: 'Carnes y despojos comestibles',
        porcentajeDetraccion: '4%'
    },
    {
        codigo: '015',
        descripcion: 'Abonos, cueros y pieles de origen animal',
        porcentajeDetraccion: '1.5%'
    },
    {
        codigo: '016',
        descripcion: 'Aceite de pescado',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '017',
        descripcion: 'Harina, polvo y “pellets” de pescado, crustáceos, moluscos y demás invertebrados acuáticos',
        porcentajeDetraccion: '4%'
    },
    {
        codigo: '019',
        descripcion: 'Arrendamiento de bienes muebles',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '020',
        descripcion: 'Mantenimiento y reparación de bienes muebles',
        porcentajeDetraccion: '12%'
    },
    {
        codigo: '021',
        descripcion: 'Movimiento de carga',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '022',
        descripcion: 'Otros servicios empresariales',
        porcentajeDetraccion: '12%'
    },
    {
        codigo: '024',
        descripcion: 'Comisión mercantil',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '025',
        descripcion: 'Fabricación de bienes por encargo',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '026',
        descripcion: 'Servicio de transporte de personas',
        porcentajeDetraccion: '10%'
    },
    // {
    //     codigo: '027',
    //     descripcion: 'Servicio de transporte de carga',
    //     porcentajeDetraccion: '10%'
    // },
    // {
    //     codigo: '028',
    //     descripcion: 'Transporte de pasajeros',
    //     porcentajeDetraccion: '10%'
    // },
    {
        codigo: '030',
        descripcion: 'Contratos de construcción',
        porcentajeDetraccion: '4%'
    },
    {
        codigo: '031',
        descripcion: 'Oro gravado con el IGV',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '034',
        descripcion: 'Minerales metálicos no auríferos',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '035',
        descripcion: 'Bienes exonerados del IGV',
        porcentajeDetraccion: '1.5%'
    },
    {
        codigo: '036',
        descripcion: 'Oro y demás minerales metálicos exonerados del IGV',
        porcentajeDetraccion: '1.5%'
    },
    {
        codigo: '037',
        descripcion: 'Demás servicios gravados con el IGV',
        porcentajeDetraccion: '12%'
    },
    {
        codigo: '039',
        descripcion: 'Minerales no metálicos',
        porcentajeDetraccion: '10%'
    },
    {
        codigo: '040',
        descripcion: 'Bien inmueble gravado con IGV',
        porcentajeDetraccion: '4%'
    }
]

export const tipoDocumentosRelaciondos = [
    {
    codigo: "01",
    nombre: "Factura – emitida para corregir error en el RUC"
    },
    // {
    // codigo: "02",
    //     nombre: "Factura – emitida por anticipos"
    // },
    // {
    // codigo: "03",
    //     nombre: "Boleta de Venta – emitida por anticipos"
    // },
    {
    codigo: "04",
        nombre: "Ticket de Salida - ENAPU"
    },
    {
    codigo: "05",
        nombre: "Código SCOP"
    },
    {
    codigo: "99",
        nombre: "Otros"
    }
];
export const entidadEmisora = [
    {nombre: "Seleccione Entidad"},
    {codigo: "01", nombre: "Superintendencia Nacional de Control de Servicios de Seguridad, Armas, Municiones y Explosivos de Uso Civil", abreviatura:"AMECA"},
    {codigo: "02", nombre: "Dirección General de Medicamentos Insumos y Drogas", abreviatura:"DIGEMID"},
    {codigo: "03", nombre: "Dirección General de Salud Ambiental", abreviatura:"DIGESA"},
    {codigo: "04", nombre: "Servicio Nacional de Sanidad Agraria", abreviatura:"SENASA"},
    {codigo: "05", nombre: "Servicio Nacional Forestal y de Fauna Silvestre", abreviatura:"SERFOR"},
    {codigo: "06", nombre: "Ministerio de Transportes y Comunicaciones", abreviatura:"MTC"},
    {codigo: "07", nombre: "Ministerio de la Producción", abreviatura:"PRODUCE"},
    {codigo: "08", nombre: "Ministerio del Ambiente", abreviatura:"MIN. AMBIENTE"},
    {codigo: "09", nombre: "Organismo Nacional de Sanidad Pesquera", abreviatura:"SANIPES"},
    {codigo: "10", nombre: "Municipalidad Metropolitana de Lima", abreviatura:"MML"},
    {codigo: "11", nombre: "Ministerio de Salud", abreviatura:"MINSA"},
    {codigo: "12", nombre: "Gobierno Regional", abreviatura:"GR"},

];
export const documentoRelacionado = [
    {codigo: "0", nombre: "Tipo Documento"},
    {codigo: "01", nombre: "Factura"},
    {codigo: "03", nombre: "Boleta de venta"},
    {codigo: "07", nombre: "Nota de crédito"},
    {codigo: "08", nombre: "Nota de débito"},
    {codigo: "09", nombre: "Guía de remisión remitente"},
    {codigo: "16", nombre: "Boleto de viaje emitido por las empresas de transporte público interprovincial de pasajeros"},
    {codigo: "21", nombre: "Conocimiento de embarque por el servicio de transporte de carga marítima"},
    {codigo: "23", nombre: "Pólizas de Adjudicación por remate o adjudicación de bienes"},
    {codigo: "28", nombre: "Etiquetas por el pago de la Tarifa Unificada de Uso de Aeropuerto – TUUA"},
    {codigo: "30", nombre: "Documentos de pago con tarjetas de crédito y débito"},
    {codigo: "31", nombre: "Guía de remisión transportista"},
    {codigo: "43", nombre: "Boleto de compañías de aviación transporte aéreo no regular"},
    {codigo: "04", nombre: "Liquidación de compra"},

]


